
export const LOAD_ALL_EXAM = "LOAD_ALL_EXAM";
